import { useEffect } from 'react'

import {
  securitiBackendUrl,
  securitiDomainUuid,
  securitiScriptUrl,
  securitiTenantUuid,
  securitiScriptId,
} from '../environment'

const useCookieConsent = (userId) => {
  useEffect(() => {
    if (document.getElementById(securitiScriptId)) {
      if (userId && window.setConsentBannerParams) {
        window.setConsentBannerParams({ uuid: userId })
      }
      return
    }

    const script = document.createElement('script')
    script.id = securitiScriptId
    script.src = securitiScriptUrl
    script.setAttribute('data-tenant-uuid', securitiTenantUuid)
    script.setAttribute('data-domain-uuid', securitiDomainUuid)
    script.setAttribute('data-backend-url', securitiBackendUrl)
    script.setAttribute('data-skip-css', 'false')
    script.defer = true

    script.onload = () => {
      if (userId && window.setConsentBannerParams) {
        window.setConsentBannerParams({ uuid: userId })
      }
    }

    const parentNode = document.head || document.body
    parentNode.appendChild(script)
    // eslint-disable-next-line
    return () => {
      const existingScript = document.getElementById(securitiScriptId)
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [userId])
}

export default useCookieConsent
